import {getMethod, postMethod, putMethod} from '~/api/index.js'

async function get(request, cancelToken) {
    return await getMethod('/api/venues', request, cancelToken)
}

async function post(request) {
    return await postMethod('/api/venues', request)
}

async function put(id, request) {
    return await putMethod(`/api/venues/${id}`, request)
}

export {get, post, put}
